import { FormRow } from '@gravity-ui/components';
import { DatePicker } from '@gravity-ui/date-components';
import { dateTimeParse } from '@gravity-ui/date-utils';
import { Sheet, TextInput } from '@gravity-ui/uikit';
import { useState } from 'react';
import { format } from 'date-fns';

import styles from '../styles.module.scss';
import { Calendar } from '@gravity-ui/date-components';
import { Controller } from 'react-hook-form';
import { DateField } from '@gravity-ui/date-components';
import { MobileDatePicker } from '@mui/x-date-pickers';

export const DatePickerForm = ({
	isMobile,
	formText,
	lang,
	register,
	formValues,
	setValue,
	isSubmitted,
	errors,
	control,
}: any) => {
	const [visible, setVisible] = useState(false);
	return (
		<>
			{isMobile ? (
				<>
					<FormRow className={styles.info__row} label={formText.dateBlank} required>
						{lang && (
							<DatePicker
								size="xl"
								hasClear
								timeZone="system"
								{...register('createdBlankAt', {
									required: true,
								})}
								defaultValue={
									formValues.createdBlankAt ? dateTimeParse(formValues.createdBlankAt) : undefined
								}
								onUpdate={(value) => {
									if (!value) {
										setValue('createdBlankAt', '');
										return;
									}
									const jsDate = value.toDate();
									const formatted = format(jsDate, 'yyyy-MM-dd');
									setValue('createdBlankAt', formatted);
								}}
								validationState={isSubmitted && errors.createdBlankAt ? 'invalid' : undefined}
								errorPlacement="inside"
								errorMessage={
									isSubmitted && errors.createdBlankAt ? 'Обязательно для заполнения' : undefined
								}
							/>
						)}
					</FormRow>
				</>
			) : (
				<FormRow className={styles.info__row} label={formText.dateBlank} required>
					{lang && (
						<DatePicker
							size="xl"
							hasClear
							timeZone="system"
							{...register('createdBlankAt', {
								required: true,
							})}
							defaultValue={
								formValues.createdBlankAt ? dateTimeParse(formValues.createdBlankAt) : undefined
							}
							onUpdate={(value) => {
								if (!value) {
									setValue('createdBlankAt', '');
									return;
								}
								const jsDate = value.toDate();
								const formatted = format(jsDate, 'yyyy-MM-dd');
								setValue('createdBlankAt', formatted);
							}}
							validationState={isSubmitted && errors.createdBlankAt ? 'invalid' : undefined}
							errorPlacement="inside"
							errorMessage={
								isSubmitted && errors.createdBlankAt ? 'Обязательно для заполнения' : undefined
							}
						/>
					)}
				</FormRow>
			)}
		</>
	);
};
